import { delay } from '../delay';
import { MockDataStore } from './mock-data-store';
import { filterByApplicationAreas } from './doc-functions';

export class DocsAPI {
    // This is a useless constructor right now, but its to keep it compatible with the real implementation of this API...
    // eslint-disable-next-line
    constructor(instance, inProgress, accounts, forceRefresh) {
        // Constructor, set instance level properties etc...
        this.store = new MockDataStore();
    }



    getAll = (applicationAreas) => {
        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {
                return resolve({ formats: MockDataStore.fileFormats, documentTypes: filterByApplicationAreas(applicationAreas, MockDataStore.docTypes) });
            }, delay.value());
        });
    };

}